import React from 'react'
import { PdaIconTabHeaderProps } from '../../types/common'

const PdaIconTabHeader = (props: PdaIconTabHeaderProps) => {
    return (
        <div>
            <i className={`pi ${props.icon}`} /> {/*pi pi-truck*/}
            <span className="ml-2">{props.title}</span>
        </div>
    )
}

export default PdaIconTabHeader
